module.exports = __webpack_public_path__ + "img/medal03.c9b5f88c.webp";